import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { DropdownWithSearch, Image } from "hesus-ui-kit";
import enableIcon from "@icons/ic-enable.svg";
import disableIcon from "@icons/ic-disable.svg";
import WarehouseTruckAction from "./WarehouseTruckAction";
import TruckPlateList from "../TruckPlate/TruckPlateList";
import {
  OuterWrapper,
  FlexRow,
  FilterFlexRow,
  SectionContainer,
  GridRow,
  ProductContainer,
  ButtonWrapper,
  CreateButton,
  FilterOuter,
  TruckCountLabel,
  TruckLabel,
  PriceLabel,
  HorizontalRow,
} from "./WarehouseTruckList.styled";

import "./WarehouseTruckList.scss";
import { renderPriceWithCurrency } from "@utils/utils";
import UserInfo from "@utils/UserInfo";

const ViewData = (props) => {
  const {
    t,
    carrierId,
    companyId,
    warehouseId,
    trucks,
    createWarehouseTruck,
    companyStatus,
    updateWarehouseRefeshStatus,
    countryId,
  } = props;

  const [activeStatus, setActiveStatus] = useState(true);
  const [trucksList, setTrucksList] = useState(trucks);
  const [data, setData] = useState(
    trucks ? trucks.filter((item) => item.status === activeStatus) : []
  );

  const [isRefreshDataAgain, setRefreshState] = useState(false);

  const [transportTypes, setTransportTypes] = useState([]);

  const [truckFilter, setTruckFilter] = useState([]);

  useEffect(() => {
    getFilterTrucks();
  }, [isRefreshDataAgain]);

  useEffect(() => {
    setTrucksList(trucks);
    setData(
      trucks ? trucks.filter((item) => item.status === activeStatus) : []
    );
  }, [trucks]);

  const fetchTranports = () => {
    if (!countryId) return;
    axios
      .get(
        `/transports?status=1&countries=${countryId}&orderBy=asc&limit=-1`,
        {}
      )
      .then((response) => {
        const responseData = response.data.transports.map((item) => {
          const tempData = {
            value: item.id,
            label: item.name,
          };
          return tempData;
        });
        setTransportTypes(responseData);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    fetchTranports();
  }, [countryId]);

  useEffect(() => {
    activeStatus === true
      ? setData(trucksList?.filter((truck) => truck.status === true))
      : setData(trucksList);
  }, [activeStatus]);

  useEffect(() => {
    activeStatus === true
      ? setData(trucksList?.filter((truck) => truck.status === true))
      : setData(trucksList);
  }, [trucksList]);

  const changeStatus = () => {
    setActiveStatus(!activeStatus);
  };

  const getFilterTrucks = () => {
    activeStatus === true
      ? setData(trucksList?.filter((truck) => truck.status === true))
      : setData(trucksList);
  };

  const setFilterTrucks = (value) => {
    setTruckFilter(value);
    const truckIds = value.map((item) => item.value);
    if (truckIds.length !== 0) {
      activeStatus === true
        ? setData(
            trucksList.filter(
              (items) =>
                truckIds.includes(items.truckType.id) && items.status === true
            )
          )
        : setData(
            trucksList?.filter((items) => truckIds.includes(items.truckType.id))
          );
    } else getFilterTrucks();
  };

  return (
    <>
      <OuterWrapper>
        <FlexRow>
          <SectionContainer>
            <div>
              <FilterFlexRow>
                <FilterOuter>
                  <div className="status__filters-wrapper">
                    <Image
                      src={activeStatus ? enableIcon : disableIcon}
                      alt={t("WAREHOUSE_TRUCKS_FILTER_ACTIVE_ONLY")}
                      title={t("WAREHOUSE_TRUCKS_FILTER_ACTIVE_ONLY")}
                      className="warehouses-list__image-icon"
                      onClick={() => changeStatus()}
                    />
                    <label className="label warehouses-list__active-label">
                      {t("WAREHOUSE_TRUCKS_FILTER_ACTIVE_ONLY")}
                    </label>
                  </div>
                  <DropdownWithSearch
                    id="transport-types"
                    label={t("TRANSPORT_TYPES")}
                    placeholder={t("TRANSPORT_TYPES")}
                    name="transportType"
                    labelClass="center-product-price__transport-type"
                    containerClass="center-product-price-list__transport-list-dropdown-container"
                    value={truckFilter}
                    defaultOption={null}
                    onChange={setFilterTrucks}
                    options={transportTypes}
                    containerStyles={{
                      minWidth: "14rem",
                    }}
                    ismulti
                  />
                </FilterOuter>

                <ButtonWrapper onClick={createWarehouseTruck}>
                  <CreateButton>{`${t(
                    "ACTION_NEW_WAREHOUSE_TRUCK"
                  )}`}</CreateButton>
                </ButtonWrapper>
              </FilterFlexRow>
            </div>
            <div>
              <GridRow column="repeat(auto-fit, minmax(400px, 450px));">
                {data.length !== "" &&
                  data.map((data, index) => {
                    return (
                      <ProductContainer key={index}>
                        <GridRow column="20% 60% auto" gap="0rem">
                          <TruckCountLabel
                            opacity={!data.status ? ".5" : 1}
                            color={!data.status ? "#cccccc" : "#00aeea"}
                          >
                            {data.count}
                          </TruckCountLabel>
                          <div>
                            <TruckLabel
                              opacity={!data.status ? ".5" : 1}
                              color={!data.status ? "#cccccc" : "#00aeea"}
                            >
                              {data.truckType.name}
                            </TruckLabel>
                            <PriceLabel
                              opacity={!data.status ? ".5" : 1}
                              color={!data.status ? "#cccccc" : "#474747"}
                            >
                              {renderPriceWithCurrency(
                                data.price,
                                t(data.unit),
                                data.currency?.symbol,
                                data.currency?.position
                              )}
                            </PriceLabel>
                          </div>
                          <WarehouseTruckAction
                            createWarehouseTruck={createWarehouseTruck}
                            data={data}
                            companyId={companyId}
                            onRefreshData={setRefreshState}
                            companyStatus={companyStatus}
                            carrierId={carrierId}
                            warehouseId={warehouseId}
                            setData={getFilterTrucks}
                            setTrucksList={setTrucksList}
                            updateWarehouseRefeshStatus={
                              updateWarehouseRefeshStatus
                            }
                          />
                        </GridRow>
                        {!!data.status && (
                          <>
                            <HorizontalRow />
                            <TruckPlateList
                              plateData={data?.plates}
                              truckId={data?.id}
                              updateWarehouseRefeshStatus={
                                updateWarehouseRefeshStatus
                              }
                            />
                          </>
                        )}
                      </ProductContainer>
                    );
                  })}
              </GridRow>
              {(data.length === "" || data.length === 0) && (
                <GridRow column="1fr">{t("NO_WAREHOUSE_TRUCKS")}</GridRow>
              )}
            </div>
          </SectionContainer>
        </FlexRow>
      </OuterWrapper>
    </>
  );
};

ViewData.propTypes = {
  t: PropTypes.func.isRequired,
  isRefreshList: PropTypes.bool.isRequired,
};

export default withTranslation()(ViewData);
